import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { startOfDay, endOfDay, subDays } from 'date-fns'
import { fromZonedTime } from 'date-fns-tz'

import api from '../../../api/api'
import AnalyticsCard from '../components/AnalyticsCard/AnalyticsCard'
import { mapReservationsAnalytics } from '../helpers'

import AnalyticsNavbar from './AnalyticsNavbar'

const DEFAULT_DAYS_RANGE = 30

const ReservationsAnalytics = ({ building }) => {
  const { t } = useTranslation(['reservations'])
  const [isSiteLoading, setSiteLoading] = useState(false)
  const [analytics, setAnalytics] = useState(null)
  const [dateRange, setDateRange] = useState([
    subDays(startOfDay(Date.now()), DEFAULT_DAYS_RANGE),
    startOfDay(Date.now()),
  ])

  const [dateStart, dateEnd] = dateRange

  const fetchAnalytics = async () => {
    try {
      setSiteLoading(true)
      const params = {
        buildingId: building.id,
        dateStart: dateStart
          ? fromZonedTime(startOfDay(dateStart), building.timezone || 'America/Chicago').getTime()
          : undefined,
        dateEnd: dateEnd
          ? fromZonedTime(endOfDay(dateEnd), building.timezone || 'America/Chicago').getTime()
          : undefined,
      }
      const result = await api.fetchReservationsAnalytics(params)
      setAnalytics(result.data)
    } catch ({ message }) {
      console.error(message)
    } finally {
      setSiteLoading(false)
    }
  }

  useEffect(() => {
    const dateFilter = (dateStart && dateEnd) || (!dateStart && !dateEnd)

    if (building && dateFilter) {
      fetchAnalytics()
    }
  }, [building, dateStart, dateEnd])

  return (
    <div className={`reservations-analytics ${isSiteLoading ? 'is-loading' : ''}`}>
      <AnalyticsNavbar dateRange={dateRange} setDateRange={setDateRange} />
      <div className="reservations-analytics-cards">
        {analytics &&
          mapReservationsAnalytics(analytics, t).map((item) => (
            <AnalyticsCard key={item.id} {...item} />
          ))}
      </div>
    </div>
  )
}

ReservationsAnalytics.propTypes = {
  building: PropTypes.object,
}

export default ReservationsAnalytics
